<script>
    import { onMount } from "svelte";
    import Cinema from "../components/Cinema.svelte";
    import ajaxFetch from "../services/ajaxFetch";

    let { errorCallback, variationId, featureIndex, performance, eventMergeId, cinemaInjectionContainerWidth } =
        $props();

    let cinemaHasLoaded = $state(false);
    let headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const res = await ajaxFetch(`/reco-core/recommendations/complementary/variations/${variationId}`);
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({ headline, recommendations, tracking, additionalClickTracking, metaData, featuresState } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_complementary_cinema_wrapper">
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaMeta={metaData}
            {performance}
            trackingEventMergeId={eventMergeId}
            loadedTrackingActionName="change"
            site="RecoDetailViewComplementary"
        />
    </div>
{/if}

<style lang="scss">
    .reco_complementary_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;
    }
</style>
